import { Navigate } from "react-router-dom";

const AuthRoute = ({children}) => {
const token = localStorage.getItem('agentModuleToken');
  if(token){
    return children;
  }else{
    return <Navigate to='/login' />
  }
};

export default AuthRoute;
